import { Button } from 'antd';
import type { ComponentProps } from 'react';
import React, { useCallback } from 'react';

import { DatePicker } from 'app/components/fields/dayjsPickers';
import { addMonths, dayjs } from 'app/utils/dayjs';

export const DatePickerWithHelper = ({
  value,
  onChange,
  ...props
}: DatePickerWithHelperProps) => {
  const handleChange = useCallback(
    (date: Date | null) => {
      if (onChange) {
        onChange(date || new Date());
      }
    },
    [onChange]
  );

  return (
    <>
      <DatePicker
        {...props}
        value={value ? dayjs(value) : undefined}
        onChange={(date) => handleChange(date ? date.toDate() : null)}
        format="ddd DD MMM"
      />
      <Button onClick={() => handleChange(addMonths(value ?? new Date(), 1))}>
        +1 month
      </Button>
      <Button onClick={() => handleChange(addMonths(value ?? new Date(), 3))}>
        +3 months
      </Button>
    </>
  );
};

type DatePickerWithHelperProps = Omit<
  ComponentProps<typeof DatePicker>,
  'value' | 'onChange'
> & {
  value?: Date;
  onChange?: (date: Date) => void;
};
